<i18n>
{
  "fr": {
    "document-title": "Titre",
    "document-title-placeholder": "Titre",
    "document-link": "Lien",
    "document-link-placeholder": "Lien",
    "document-details": "Détails",
    "document-details-placeholder": "Détails",
    "document-cancel-btn": "Annuler",
    "document-reset-btn": "Réinitialiser",
    "document-reset-title": "Réinitialiser le document",
    "document-reset-message": "Êtes-vous certain de vouloir réinitialiser le document? Le titre et les détails seront remplacés par le texte par défaut pour ce document, <strong>et le lien sera supprimé</strong>.",
    "document-reset-confirm": "Réinitialiser",
    "document-reset-cancel": "Annuler",
    "error-document-title": "Le titre est obligatoire"
  },
  "en": {
    "document-title": "Title",
    "document-title-placeholder": "Title",
    "document-link": "Link",
    "document-link-placeholder": "Link",
    "document-details": "Details",
    "document-details-placeholder": "Details",
    "document-cancel-btn": "Cancel",
    "document-reset-btn": "Reset",
    "document-reset-title": "Reset document",
    "document-reset-message": "Are you sure that you want to reset the document? The title and details will be replaced by the default text for this document, <strong>and the link will be deleted</strong>.",
    "document-reset-confirm": "Reset",
    "document-reset-cancel": "Cancel",
    "error-document-title": "The title is required"
  }
}
</i18n>

<template>
  <s-form @submit="onSubmit" ref="documentForm">
    <h3 class="title is-5 has-text-weight-bold mb-12px">{{ title }}</h3>

    <!-- Titre -->
    <s-field
      :label="$t('document-title')"
      label-for="document-title"
      :value="model.title"
      :rules="rules.documentTitle"
      validate-on-input
    >
      <b-input v-model="model.title" :placeholder="$t('document-title-placeholder')" id="document-title" />
    </s-field>

    <!-- Détail -->
    <s-field :label="$t('document-details')" label-for="document-details" :value="model.content">
      <b-input type="textarea" v-model="model.content" :placeholder="$t('document-details-placeholder')" id="document-details" />
    </s-field>

    <!-- Lien -->
    <s-field :label="$t('document-link')" label-for="document-link" :value="model.link">
      <b-input v-model="model.link" :placeholder="$t('document-link-placeholder')" id="document-link" />
    </s-field>

    <!-- Boutons -->
    <div>
      <b-button type="is-link" outlined native-type="button" class="mr-12px" @click="$emit('cancel')">
        {{ $t('document-cancel-btn') }}
      </b-button>
      <!-- Fonctionnalité Réinitialiser cachée sur demande de la cliente.
        <b-button type="is-danger is-light" v-if="model.hasOverride" class="mr-12px" @click="resetDocument">
        {{ $t('document-reset-btn') }}
      </b-button> -->
      <b-button type="is-link" native-type="submit" :loading="loading">
        {{ submitLabel }}
      </b-button>
    </div>
  </s-form>
</template>
<script>
import FormHelper from '@/helpers/form'
import SForm from '@/components/form/form'
import SField from '@/components/form/field'

export default {
  components: { SForm, SField },
  props: {
    loading: Boolean,
    title: String,
    submitLabel: String,
    document: Object
  },
  data() {
    return {
      model: this.document ? { ...this.document } : {}
    }
  },
  computed: {
    rules() {
      return {
        documentTitle: [(value) => FormHelper.notEmpty(value) || this.$t('error-document-title')]
      }
    }
  },
  methods: {
    onSubmit() {
      if (!this.$refs.documentForm.validate()) return
      this.$emit('submit', this.model)
    }
    /* Fonctionnalité réinitialiser désactivée sur demande de la cliente.
    resetDocument() {
      this.$buefy.dialog.confirm({
        title: this.$t('document-reset-title'),
        message: this.$t('document-reset-message'),
        confirmText: this.$t('document-reset-confirm'),
        cancelText: this.$t('document-reset-cancel'),
        type: 'is-danger',
        onConfirm: () => {
          this.model.title = null
          this.model.content = null
          this.model.link = null

          this.$emit('submit', this.model)
        }
      })
    }*/
  },
  watch: {
    document(doc) {
      this.model = doc ? { ...doc } : {}
    }
  }
}
</script>
